<template>
  <div class="idea-item">
    <div :class="'idea-entry ' + ideaExpandContract">
      <div class="d-flex pt-2">
        <img class="border border-secondary rounded author-pic" :src="authorPic" width="100" height="100">
        <div class="ml-4">
          <div v-if="isGraduated" class="float-right ml-2" v-b-tooltip.hover title="This idea has been graduated">
            <i style="color: darkgoldenrod" class="fas fa-star fa-fw fa-2x"></i>
          </div>
          <img class="float-right" :src="'static/' + country + '.svg'" width="50" height="33">
          <h4 v-html="ideaTitle"></h4>
          <ul class="list-inline pb-2">
            <li class="list-inline-item text-black-50" title="Idea challenge">
              <small>
                <i class="fas fa-trophy fa-fw"></i>
                <span class="listLink" v-for="ideaCategory in ideaCategories" v-bind:key="ideaCategory.id" title="Idea Challenge category" v-html="ideaCategory.name"></span>
                <!-- <router-link class="listLink" v-for="ideaCategory in ideaCategories" v-bind:key="ideaCategory.id" :to="'/idea-challenges/idea-challenge/' + ideaCategory.slug" :class="'idea-category-' + ideaCategory.id">
                  {{ideaCategory.name}}
                </router-link> -->
              </small>
            </li>
            <li class="list-inline-item text-black-50" title="Idea author">
              <small><i class="fas fa-user fa-fw"></i> <router-link :to="'/thinktank-user/' + authorSlug">{{author}}</router-link></small>
            </li>
            <li v-if="!excerpt" class="list-inline-item text-black-50" title="Communities">
              <small>
                <i class="fas fa-users fa-fw"></i>
                <router-link class="listLink" v-for="comCategory in communityCategories" v-bind:key="comCategory.id" :to="'/communities/community/' + comCategory.name.replace(/ /g, '-').toLowerCase()">{{comCategory.name}}</router-link>
              </small>
            </li>
            <li class="list-inline-item text-black-50">
              <small><i class="fas fa-clock fa-fw"></i> {{date.substring(0, 10)}}</small>
            </li>
            <li v-if="excerpt" class="list-inline-item text-black-50">
              <small><i class="fas fa-comments fa-fw"></i> {{commentCount}}</small>
            </li>
          </ul>
          <article v-if="!excerpt" v-html="content" ref="ideaContent"></article>
          <router-link v-if="supportingDoc !== undefined" :to="'/supporting-documentation/' + supportingDoc" target="_blank" class="btn btn-primary mb-3">View supporting documentation</router-link>
        </div>
      </div>
      <div class="comments">
        <h4 v-if="!excerpt && comments !== undefined" class="text-black-50">Comments</h4>
        <Comments v-if="!excerpt" :comments="comments" :post-id="postId"></Comments>
      </div>
    </div>
    <div v-if="!excerpt" class="idea-meta">
      <hr>
      <ul class="list-inline">
        <li class="list-inline-item text-black-50">
          <span>{{commentCount}}</span>
          <button @click="expandIdea()" type="button" class="btn btn-link p-0">
             <i class="fas fa-comments fa-sm fa-fw"></i>
          </button>
        </li>
        <li class="list-inline-item text-black-50" v-b-tooltip.hover title="Like this idea">
          <span>{{likes}}</span>
          <button class="btn btn-link p-0" type="button" v-on:click="likeIdea()">
            <i class="fas fa-thumbs-up fa-sm fa-fw"></i>
            <!-- <i class="fa fa-cog fa-spin fa-sm fa-fw"></i> -->
          </button>
        </li>
        <li class="list-inline-item text-black-50" v-b-tooltip.hover title="Follow this idea">
          <button class="btn btn-link p-0" type="button" title="Follow this idea" v-on:click="followIdea()">
            <i class="fas fa-lightbulb fa-sm fa-fw"></i>
          </button>
        </li>
        <li class="list-inline-item text-black-50" v-b-tooltip.hover title="Report abuse">
          <button class="btn btn-link p-0" type="button" v-b-modal="'reportAbuse' + postId"><i class="fas fa-exclamation-triangle fa-sm fa-fw"></i></button>
        </li>
        <span v-if="isAdmin">
          <button type="button" class="btn btn-link p-0" v-on:click="showAdminControls = !showAdminControls"><i class="fas fa-cog fa-fw"></i></button>
          <transition name="fade">
            <span v-if="showAdminControls">
              <button type="button" class="btn btn-link p-0" style="color: red"><i class="fas fa-flag fa-fw"></i> Flag inappropriate</button>
              <button type="button" class="btn btn-link p-0" style="color: forestgreen"><i class="fas fa-flag fa-fw"></i> Flag appropriate</button>
              <button type="button" class="btn btn-link p-0" style="color: darkgoldenrod" v-on:click="graduateIdea()"><i class="fas fa-star fa-fw"></i> {{graduatedText}} this idea</button>
            </span>
          </transition>
        </span>
        <li class="list-inline-item text-black-50 float-right expand-btn">
          <button @click="expandIdea()" type="button" class="btn btn-link" v-html="expandContractContent"></button>
        </li>
      </ul>
    </div>
    <b-modal :id="'reportAbuse' + postId" :hide-footer="true">
      <ReportAbuse :idea-title="ideaTitle" :idea-id="postId"></ReportAbuse>
    </b-modal>
  </div>
</template>

<script>
import Comments from '@/components/Comments'
import ReportAbuse from '@/components/ReportAbuse'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import {BModal} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
export default {
  props: [
    'postId',
    'postSlug',
    'country',
    'ideaTitle',
    'authorPic',
    'ideaCategories',
    'author',
    'authorSlug',
    'communityCategories',
    'date',
    'content',
    'comments',
    'likes',
    'excerpt',
    'supportingDoc'
  ],
  components: {
    Comments,
    'b-modal': BModal,
    ReportAbuse
  },
  computed: {
    commentCount: function () {
      if (this.comments) {
        return this.comments[0].length
      } else {
        return 0
      }
    },
    isGraduated: function () {
      return this.ideaCategories.map(x => x.name).includes('Graduated idea')
    },
    graduatedText: function () {
      if (this.isGraduated) {
        return 'Ungraduate'
      } else {
        return 'Graduate'
      }
    },
    ...mapGetters([
      'isAdmin',
      'dashedName'
    ])
  },
  data () {
    return {
      expandState: false,
      divHeight: 185,
      expandContractContent: '<i class="fas fa-angle-down fa-lg fa-fw"></i>Expand',
      likedByViewer: false,
      showAdminControls: false,
      ideaExpandContract: '',
      ideaChallengeCategories: null
    }
  },
  created () {
    // this.ideaCategories = this.ideaCategories.filter(x => x.name !== 'Graduated idea')
    // if (this.$store.state.IdeaCategories.ideaCategories === null) {
    //   this.$store.dispatch('loadIdeaCategories')
    //     .then(response => {
    //       this.ideaChallengeCategories = this.$store.state.IdeaCategories.ideaCategories
    //     })
    //     .catch(error => {
    //       console.error(error)
    //       this.ideaChallengeCategories = null
    //     })
    // } else {
    //   this.ideaChallengeCategories = this.$store.state.IdeaCategories.ideaCategories
    // }
  },
  methods: {
    graduateIdea: function () {
      let ideaCategoryIDs = this.ideaCategories.map(x => x.id)
      if (this.isGraduated) {
        ideaCategoryIDs = ideaCategoryIDs.filter(x => x !== 29)
      } else {
        ideaCategoryIDs[ideaCategoryIDs.length] = 29
      }

      var self = this
      var updateIdea = {
        method: 'POST',
        data: {
          idea_chalenge_category: ideaCategoryIDs
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      WordpressRestAPI.endpointWithAuthetication(updateIdea, 'idea/' + self.postId)
        .then(function (response) {
          console.log(response.data)
          console.log(response.status)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    getIdeaChallengeRoute: function (ideaChallengeCategoryID) {
      let destinationLink
      if (this.ideaChallengeCategories.filter(x => x.id === ideaChallengeCategoryID)[0].parent === 0) {
        destinationLink = this.ideaChallengeCategories.filter(x => x.id === ideaChallengeCategoryID)[0].slug
      } else {
        let parentID = this.ideaChallengeCategories.filter(x => x.id === ideaChallengeCategoryID)[0].parent
        destinationLink = this.ideaChallengeCategories.filter(x => x.id === parentID)[0].slug
      }

      if (destinationLink === 'make-your-mark') {
        return '/make-your-mark'
      } else {
        return '/idea-challenges/idea-challenge/' + destinationLink
      }
    },
    getExpandHeight: function (contentHeight) {
      var totalHeight
      if (this.comments) {
        totalHeight = contentHeight + 70 + (this.comments[0].length * 160) + 60 + 193
      } else {
        totalHeight = contentHeight + 70 + 249
      }
      if (totalHeight < 185) {
        return 185
      } else {
        return totalHeight
      }
    },
    expandIdea: function () {
      if (this.expandState) {
        // this.divHeight = 185
        this.ideaExpandContract = ''
        this.expandContractContent = '<i class="fas fa-angle-down fa-lg fa-fw"></i>Expand'
      } else {
        // this.divHeight = this.getExpandHeight(this.$refs.ideaContent.clientHeight)
        this.ideaExpandContract = 'idea-entry-expanded'
        this.expandContractContent = '<i class="fas fa-angle-up fa-lg fa-fw"></i>Contract'
      }
      this.expandState = !this.expandState
    },
    updateIdeaLikeCount: function (increment) {
      var self = this
      const updateIdeaLikeCount = {
        method: 'POST',
        data: {
          total_likes: parseInt(this.likes) + parseInt(increment),
          status: 'publish'
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }

      WordpressRestAPI.endpointWithAuthetication(updateIdeaLikeCount, 'idea/' + this.postId)
        .then(function (response) {
          console.log(response.data)
          self.likes = parseInt(self.likes) + parseInt(increment)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    createLikePost: function () {
      var self = this
      const likeIdea = {
        method: 'POST',
        data: {
          title: this.$store.getters.getUserName + ' liked idea: ' + this.ideaTitle,
          idea_post_id: this.postId,
          status: 'publish'
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }

      WordpressRestAPI.endpointWithAuthetication(likeIdea, 'like')
        .then(function (response) {
          console.log(response.data)
          console.log(response.status)
          self.updateIdeaLikeCount(1)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    deleteLikePost: function (postID) {
      var self = this
      const likeIdea = {
        method: 'DELETE',
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }

      WordpressRestAPI.endpointWithAuthetication(likeIdea, 'like/' + postID + '?force=true')
        .then(function (response) {
          console.log(response.data)
          console.log(response.status)
          self.updateIdeaLikeCount(-1)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    likeIdea: function () {
      WordpressRestAPI.getViewContent('like?slug=' + this.dashedName + '-liked-idea-' + this.postSlug)
        .then(response => {
          console.log(response.data)
          if (response.data.length === 0) {
            console.log('not liked before')
            this.createLikePost()
          } else {
            console.log('already liked before')
            this.deleteLikePost(response.data[0].id)
          }
        })
        .catch(e => {
          console.error(e)
        })
    },
    createFollowPost: function () {
      const followIdeaOptions = {
        method: 'POST',
        data: {
          title: this.$store.getters.getUserName + ' followed idea: ' + this.ideaTitle,
          idea_post_id_follow: this.postId,
          status: 'publish'
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }

      WordpressRestAPI.endpointWithAuthetication(followIdeaOptions, 'follow')
        .then(function (response) {
          console.log(response.data)
          console.log(response.status)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    deleteFollowPost: function (postID) {
      const followIdeaOptions = {
        method: 'DELETE',
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }

      WordpressRestAPI.endpointWithAuthetication(followIdeaOptions, 'follow/' + postID + '?force=true')
        .then(function (response) {
          console.log(response.data)
          console.log(response.status)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    followIdea: function () {
      WordpressRestAPI.getViewContent('follow?slug=' + this.dashedName + '-followed-idea-' + this.postSlug)
        .then(response => {
          console.log(response.data)
          if (response.data.length === 0) {
            console.log('not followed before')
            this.createFollowPost()
          } else {
            console.log('already followed before')
            this.deleteFollowPost(response.data[0].id)
          }
        })
        .catch(e => {
          console.error(e)
        })
    }
  }
}
</script>

<style lang="less">
  .idea-entry {
    overflow: hidden;
    transition: all 0.5s;
    height: 185px;
  }
  .idea-entry-expanded {
    height: 100%;
  }
  .listLink {
    &::after {
      content: ', '
    }
    &:last-child {
      &::after {
        content: ''
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Idea.vue